/* eslint-disable */
import React from 'react'
import {Link, Redirect} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import $ from 'jquery'
import cookie from 'react-cookies'
import {message} from 'antd'
import {Button} from 'mdbreact'
import MyDatePicker from '../BaseComponent/DatePicker'
import {createAccess, createRefresh, loadAccessToken} from '../Cookie/cookie'
import {loadBrand} from '../BaseComponent/configTheme'

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      errorUsername: '',
      errorPass: '',
      redirect: false,
      connect: '',
      idphone: 7682
    }
  }

  componentDidMount() {
    if (loadAccessToken()) {
      this.props.history.push('/dashboard')
    }

    $(function() {
      $('.header').hide()
    })

    if (cookie.load('accessToken')) {
      this.setState({
        redirect: !this.state.redirect
      })
    }

    http
      .get(`public/application/ok`, {})
      .then((response) => {
        this.setState({
          connect: ''
        })
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        this.setState({
          connect: 'اتصال با سیستم برقرار نیست'
        })
      })
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to="/dashboard" />
    }
  }

  changeFieldLoginForm(event) {
    const target = event.target
    const value = target.value
    const name = target.name
    this.setState({
      [name]: value
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleLogin(event) {
    event.preventDefault()
    const {username} = this.state
    const {password} = this.state
    const data = {
      username: this.convertDigit(username),
      password: this.convertDigit(password)
    }
    // alert(JSON.stringify(data))

    if (username === '') {
      this.setState({
        errorUsername: 'نام کاربری را وارد کنید'
      })
    } else if (password === '') {
      this.setState({
        errorPass: 'کلمه عبور را وارد کنید'
      })
    } else {
      this.setState({
        errorUsername: '',
        errorPass: ''
      })

      http
        .post(`public/user/login`, data, {})
        .then((response) => {
          if (response.data.error == null) {
            var expDate = new Date()
            expDate.setTime(expDate.getTime() + 10 * 3600 * 1000)
            // sessionStorage.setItem('accessToken', response.data.object.accessToken);
            // sessionStorage.setItem('BaccessToken', response.data.object.accessToken);
            localStorage.setItem('personId', response.data.object.personId)
            localStorage.setItem('internalNumber', response.data.object.internalNumber)
            localStorage.setItem('permissions', JSON.stringify(response.data.object.permissions))
            // sessionStorage.setItem('refreshToken', response.data.object.refreshToken);
            // sessionStorage.setItem('BrefreshToken', response.data.object.refreshToken);
            sessionStorage.setItem('name', response.data.object.firstname + ' ' + response.data.object.lastname)
            cookie.save('name', response.data.object.firstname + ' ' + response.data.object.lastname, {
              path: '/',
              expires: expDate
            })

            // cookie.save('accessToken', response.data.object.accessToken, {path: '/', expires: expDate});
            // cookie.save('BaccessToken', response.data.object.accessToken, {path: '/', expires: expDate});
            createAccess(response.data.object.accessToken)
            createRefresh(response.data.object.refreshToken)
            // cookie.save('refreshToken', response.data.object.refreshToken, {path: '/', expires: expDate});
            // cookie.save('BrefreshToken', response.data.object.refreshToken, {path: '/', expires: expDate});
            // this.props.history.push('/dashboard')
            window.location.assign('/dashboard')
          } else {
            // message.error(response.data.description)
          }
        })
        .catch(() => {})
    }
  }

  render() {
    let {idphone} = this.state

    return (
      <div>
        <div className="container">
          <div className="formWrapperHome" style={{background: loadBrand().color}}>
            <div className="logoHome">
              <img src={loadBrand().logo} alt="logo" />
              <p>به {loadBrand().title} خوش آمدید</p>
            </div>
            <form className="loginForm" onSubmit={this.handleLogin.bind(this)}>
              <div className="banerLoginForm">
                <p>فرم ورود</p>
              </div>
              <div className="formComponent">
                <label for="user">نام کاربری</label>
                <input
                  type="text"
                  id="user"
                  name="username"
                  className="form-control"
                  onChange={this.changeFieldLoginForm.bind(this)}
                />
                <p className="errorText">{this.state.errorUsername}</p>

                <label for="password">کلمه عبور</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  className="form-control"
                  onChange={this.changeFieldLoginForm.bind(this)}
                />

                <p className="errorText">{this.state.errorPass}</p>

                <Link to={'/ForgetPass'}>کلمه عبور خود را فراموش کردید؟؟</Link>
                <Button block color="warning" type="submit" rounded>
                  ورود کاربر
                </Button>
                {/*{this.renderRedirect()}*/}
                {/*<a href= {`/shop/${idphone}`}  > ورود به خرید اینترنتی</a>*/}

                <p className="errorText">{this.state.connect}</p>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export default Home
